<template>
    <button
        type="button"
        :class="[
            'custom-navbar__item inline-flex items-center bg-transparent border-0',
            'px-2 py-1.5 text-sm font-bold transition-opacity duration-200',
            active ? 'active opacity-100' : 'opacity-70 hover:opacity-100'
        ]"
        @click="onClick"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "CustomNavbarItem",
    inject: {
        customNavbar: {
            default: () => ({
                setModel: () => {},
                setLeftLine: () => {},
                setWidthLine: () => {},
                setTopLine: () => {}
            })
        }
    },
    props: {
        active: { type: Boolean, default: false },
        to: { type: [String, Object], default: null },
        id: { type: String, default: null },
        href: { type: String, default: null },
        target: { type: String, default: "_blank" }
    },
    watch: {
        active() {
            this.updateLine();
        }
    },
    mounted() {
        setTimeout(() => {
            if (this.active) this.updateLine();
        }, 150);
    },
    methods: {
        updateLine() {
            this.$nextTick(() => {
                if (!this.active) return;
                this.customNavbar.setLeftLine(this.$el.offsetLeft);
                this.customNavbar.setWidthLine(this.$el.scrollWidth);
                this.customNavbar.setTopLine(
                    this.$el.offsetTop + this.$el.offsetHeight
                );
            });
        },
        onClick(evt) {
            this.$emit("click", evt);
            this.updateLine();

            if (this.to) {
                this.$router.push(this.to);
            } else if (this.href) {
                window.open(this.href, this.target);
            }

            if (this.id) {
                this.customNavbar.setModel(this.id);
            }
        }
    }
};
</script>
